import ExchangeModal from '@stone/components/bag/ExchangeModal';
import { MinicartActionTypes } from '@state/features/common.types';
import api from '@utils/api';
import useMediaQueries from '@stone/hooks/useMediaQueries';
import React, { Suspense, useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import MiniBagModal from '@stone/components/minibag/MiniBagModal';
import ModalDrawer from '@stone/components/modal/ModalDrawer';
import customEventBus from '@common/scripts/libs/eventBus';
import A11YMinibagBar from '../a11y/A11YMinibagBar';
import { siteUrl } from '@common/utils/urlutils';
import ModalDialog from '../modal/ModalDialog';
const LoginModal = React.lazy(() => import('@stone/components/login/LoginModal'));
const MiniBagWrapper = (props) => {
    var _a;
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { isMobile } = useMediaQueries();
    //ugly but needed - the subchild do not has props type correctly configured
    const extendedProps = Object.assign({ termsandconditions: siteUrl('terms'), privacypolicy: siteUrl('privacy') }, props);
    const { justAdded, hovering, lastAdded, minicart } = useSelector((state) => state.minicart);
    const [isOpen, setIsOpen] = useState(false);
    const [loginOpen, setLoginOpen] = useState(false);
    const [loggedIn, setLoggedIn] = useState(window.loggedin);
    const [bag, setBag] = useState(); // only used for exchange alert, normally not loaded
    const lastAddedRef = useRef();
    lastAddedRef.current = lastAdded;
    const opener = useRef(null);
    const prevStatus = useRef(justAdded || hovering);
    const overlayVisible = useMemo(() => justAdded || hovering, [justAdded, hovering]);
    useEffect(() => {
        if (window.location.search.includes('isExchange=true')) {
            api.getFullCart().then((data) => setBag(data));
        }
        if (window.location.search.includes('openMiniCart')) {
            dispatch({ type: MinicartActionTypes.FETCH_MINICART_AND_OPEN });
        }
        // Fetch minicart once per each page in order to call restore cart
        dispatch({ type: MinicartActionTypes.FETCH_MINICART });
    }, []);
    useEffect(() => {
        // console.info('overlay visible: ', overlayVisible);
        if (overlayVisible && !prevStatus.current) {
            prevStatus.current = true;
            setIsOpen(true);
        }
        else if (prevStatus.current) {
            prevStatus.current = false;
            setIsOpen(false);
        }
    }, [overlayVisible]);
    const closeMiniBag = () => {
        var _a;
        dispatch({ type: MinicartActionTypes.CLOSE_MINICART });
        if (opener.current) {
            (_a = opener.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    };
    useEffect(() => {
        const eventOpen = (e) => {
            var _a, _b, _c, _d;
            if (!!overlayVisible)
                return false;
            if ((_b = (_a = e.data) === null || _a === void 0 ? void 0 : _a.originalEvent) === null || _b === void 0 ? void 0 : _b.target) {
                opener.current = (_d = (_c = e.data) === null || _c === void 0 ? void 0 : _c.originalEvent) === null || _d === void 0 ? void 0 : _d.target;
            }
            else {
                opener.current = null;
            }
            dispatch({ type: MinicartActionTypes.FETCH_MINICART_AND_OPEN });
        };
        customEventBus.on('minicart:askforopen', eventOpen);
        const eventClose = (e) => {
            if (!overlayVisible)
                return false;
            closeMiniBag();
        };
        customEventBus.on('minicart:askforclose', eventClose);
        return () => {
            customEventBus.off('minicart:askforopen', eventOpen);
            customEventBus.off('minicart:askforclose', eventClose);
        };
    });
    const getItemsNumber = function (nItems) {
        nItems = nItems || 0;
        return `${nItems} ${!nItems || nItems > 1 ? t('label.items') : t('label.item')}`;
    };
    return (React.createElement(React.Fragment, null,
        isMobile ? (React.createElement(ModalDialog, { fullWidth: true, noPadding: true, className: 'minibag-modal__wrapper', isOpen: isOpen, contentLabel: t('bag.justaddedshort'), onRequestClose: () => closeMiniBag() },
            React.createElement(A11YMinibagBar, null),
            React.createElement(MiniBagModal, Object.assign({ logged: loggedIn, onLoginClick: () => setLoginOpen(true), onClose: () => closeMiniBag(), updateLoggeedStatus: () => setLoggedIn(true) }, extendedProps)))) : (React.createElement(ModalDrawer, { className: 'minibag-modal__wrapper in-drawer', isOpen: isOpen, contentLabel: t('bag.summary'), subtitle: getItemsNumber((minicart === null || minicart === void 0 ? void 0 : minicart.numItems) || 0), onRequestClose: () => closeMiniBag(), a11yBar: React.createElement(A11YMinibagBar, null) },
            React.createElement(MiniBagModal, Object.assign({ logged: loggedIn, onLoginClick: () => setLoginOpen(true), onClose: () => closeMiniBag(), updateLoggeedStatus: () => setLoggedIn(true) }, extendedProps)),
            React.createElement(Suspense, { fallback: React.createElement(React.Fragment, null) },
                React.createElement(LoginModal, Object.assign({}, props, { inCart: true, modalStatus: loginOpen, updateStatus: (status) => setLoginOpen(status), updateLoggeedStatus: () => setLoggedIn(true), socialLoginTarget: "checkout" }))))),
        ((_a = bag === null || bag === void 0 ? void 0 : bag.exchangeModel) === null || _a === void 0 ? void 0 : _a.alert) && React.createElement(ExchangeModal, { bag: bag })));
};
export default MiniBagWrapper;
